export default __webpack_public_path__ + "static/media/Contact_Us.4a410a08.jpg";